const OneCommentaire = ({comment}) => {
  return (
    <li
      key={comment._id}
      className="flex flex-col w-full space-y-1 border-b border-gray-700 pb-2"
    >
      <div className="flex space-x-3 items-center">
        <span className="flex-1 text-lg text-[#c792cf] font-bold break-all">
          {comment.pseudo}
        </span>
        <span className="block text-xs text-gray-400 break-all">
          {comment._createdAt ? new Date(comment._createdAt).toLocaleString("fr-fr", {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "numeric",
          }) : comment._createdAtLocal}
          {/* {format(new Date(comment.date), "dd MMM yyyy kk:mm:ss")} */}
        </span>
      </div>
      <p className="text-gray-200 text-lg">{comment.commentaire}</p>
    </li>
  );
};

export default OneCommentaire;